import React from 'react'
import dynamic from 'next/dynamic'
import { Insight, InsightComponentProps } from 'src/components/insights/types'
import { RankIcon } from 'src/components/insights/icons/rank'
import { FullScreenLoading } from 'src/components/full-screen-loading'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { Colors } from 'src/components/theme'

const RankContent = dynamic(() => import('src/components/insights/rank/content'), {
  loading: () => <FullScreenLoading />,
  ssr: false,
})

const MobilityPage: React.FC<InsightComponentProps> = (props) => {
  const { insight } = props
  return (
    <InsightContainer insight={insight} color={Colors.purpleDark}>
      <React.Suspense fallback={<FullScreenLoading />}>
        <RankContent insight={insight} />
      </React.Suspense>
    </InsightContainer>
  )
}

export const CategoryRank: Insight = {
  id: 'category-rank',
  component: MobilityPage,
  name: 'Category Rank',
  icon: RankIcon,
  supportedResultTypes: ['alphamap-location'],
  linkTooltipFile: 'insights-link-location-rank',
}
